import register from '../../../../global/js/registry';
export default register('m-input-search-debounce', () => import(/* webpackMode: "lazy" */ './m-input-search-debounce.controller'));
